// extracted by mini-css-extract-plugin
module.exports = {"container":"GoodsList_container__3wsHl","filter":"GoodsList_filter__2qax1","goods":"GoodsList_goods__3G7aP"};